// IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
//
// Замер webscm 29.10 (CPU-профиль shiftf3-longtask): после Shift+F3 словарь SEGMENTS-UNION (fetchMode all, 3491 записей) бампает
// store.itemsSource_change_index → вотчер AttrGrid соседнего грида Stock Move (4591 строк × 29 колонок, глаз «скрыть пустые») →
// flexRefresh → flexRefresh_afterTimeout → apply_CHIPS(fast) → apply_CHIPS_columns: проход «пустые колонки» читает каждую ячейку
// каждой проверяемой колонки до первой непустой — у 10 пустых колонок это 10 × 4591 = 45 929 чтений, 423–474 мс из 0,86 с.
//
// Вердикт «колонка пуста» от словаря не зависит: проверяется сырое значение строки (id ссылки, *.value при пустом *.valueStr,
// массивы по use), а не подпись из dataMap. Поэтому проход, вызванный ТОЛЬКО приездом словаря (причина 'dict' у flexRefresh),
// берёт вердикт колонки из прошлого прохода, если с тех пор не менялось ничего, от чего он зависит (ключ — AttrGrid.emptyScan_key:
// счётчик правок данных _esDataVer (set_value / undo-redo / refresh), массив data000 и его длина, число строк и колонок грида,
// attr_by_binding, группировка / дерево чипсов, свёртка групп колонок, итоги по отбору _ftMap, глубина стеков отмены, тумблер All).
// Колонки, которых нет в кэше (новые), сканируются как раньше. Любой другой проход (смена чипсов, данных, видимости, правка) —
// полный скан, он же обновляет кэш.
//
// Выключатель fe.ux.gridEmptyScanCache (§8, по умолчанию ВКЛ, без пересборки): window.feSettings.set('fe.ux.gridEmptyScanCache', false)
// или ?fe.ux.gridEmptyScanCache=false — каждая колонка сканируется на каждом проходе, как до правки. Счётчики (тихо, без console):
// window.gridEmptyScan.get() / .set(false) / .reset() / .stats() / .clear().

export const FLAG = 'fe.ux.gridEmptyScanCache'
export const GES_DEFAULTS = { [FLAG]: true }

const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now())

const stats = {
    passes: 0,        // проходов «пустые колонки» (apply_CHIPS_columns с глазом)
    fullScans: 0,     // проходов, где сканировалась хотя бы одна колонка
    cacheHits: 0,     // проходов, целиком взятых из кэша (ни одной колонки не сканировано)
    colScans: 0,      // колонок просканировано
    colHits: 0,       // вердиктов колонок взято из кэша
    cellsScanned: 0,  // ячеек прочитано сканом
    msScan: 0,        // мс внутри скана колонок (performance.now)
    lastGrid: '',     // грид последнего прохода
    last: null,       // последний проход: { grid, reuse, hit, scanned, hits, cells, ms }
}

export function gridEmptyScan_on(store) {
    return !store || typeof store.setting !== 'function' || store.setting(FLAG, GES_DEFAULTS[FLAG]) !== false
}

// ключи совпадают поэлементно (идентичность объектов — Object.is)
export function emptyScan_sameKey(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) if (!Object.is(a[i], b[i])) return false
    return true
}

// начать проход: prev — кэш прошлого прохода ({ key, cols } | null), key — ключ сейчас; reuse — причина прохода только словарь.
// Кэш берётся, только если флаг включён, reuse и ключ тот же; иначе каждая колонка сканируется
export function emptyScan_begin(prev, key, { on = true, reuse = false, grid = '' } = {}) {
    stats.passes++
    stats.lastGrid = grid
    const hit = !!(on && reuse && prev && emptyScan_sameKey(prev.key, key))
    return { key, on: !!on, reuse: !!reuse, hit, grid, prevCols: hit ? prev.cols : null, cols: new Map(), scanned: 0, hits: 0, cells: 0, ms: 0 }
}

// вердикт колонки: из кэша прохода или сканом scan() → { empty, cells }
export function emptyScan_column(pass, binding, scan) {
    if (pass.prevCols && pass.prevCols.has(binding)) {
        const empty = pass.prevCols.get(binding)
        pass.cols.set(binding, empty)
        pass.hits++
        stats.colHits++
        return empty
    }
    const t0 = now()
    const r = scan() || {}
    const ms = now() - t0
    const empty = !!r.empty
    pass.cols.set(binding, empty)
    pass.scanned++
    pass.cells += r.cells || 0
    pass.ms += ms
    stats.colScans++
    stats.cellsScanned += r.cells || 0
    stats.msScan += ms
    return empty
}

// закончить проход → кэш для следующего ({ key, cols }) или null при выключенном флаге
export function emptyScan_end(pass) {
    if (pass.scanned) stats.fullScans++
    else if (pass.hits) stats.cacheHits++
    stats.last = { grid: pass.grid, reuse: pass.reuse, hit: pass.hit, scanned: pass.scanned, hits: pass.hits, cells: pass.cells, ms: Math.round(pass.ms * 10) / 10 }
    return pass.on ? { key: pass.key, cols: pass.cols } : null
}

export function gridEmptyScan_stats() {
    return { ...stats, msScan: Math.round(stats.msScan * 10) / 10, last: stats.last ? { ...stats.last } : null }
}

export function gridEmptyScan_clear() {
    for (const k of Object.keys(stats)) stats[k] = typeof stats[k] === 'number' ? 0 : (k === 'last' ? null : '')
    return gridEmptyScan_stats()
}

export function gridEmptyScan_console(store) {
    if (typeof window === 'undefined') return
    window.gridEmptyScan = {
        flag: FLAG,
        get: () => ({ on: gridEmptyScan_on(store), stats: gridEmptyScan_stats() }),
        set(value) { window.feSettings?.set?.(FLAG, value); return this.get() },
        reset() { window.feSettings?.unset?.(FLAG); return this.get() },
        stats: () => gridEmptyScan_stats(),
        clear: () => gridEmptyScan_clear(),
        help: () => 'gridEmptyScan.set(false) — проход «пустые колонки» сканирует каждую колонку всегда (как до 29.10); .reset() — снять override; .stats() / .clear() — счётчики',
    }
}
